/* eslint-disable */

import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { IkpEnvironmentService } from '../../service/environment/ikp-environment.service';

const mazeElementName = 'maze';
declare global {
  interface Window {
    initializeMaze: () => void;
  }
}

@Component({
  selector: 'ikp-maze',
  standalone: true,
  imports: [],
  template: `<span #${mazeElementName}></span>`,
  // TODO: IKP-1693 - This problem should be tackled together with the OnPush migration, remove at the top the eslint disable after fix
  encapsulation: ViewEncapsulation.None,
})
export class MazeComponent implements OnInit {
  envService = inject(IkpEnvironmentService);

  ngOnInit(): void {
    const mazePropertyId = this.envService.getMazePropertyId();

    if (mazePropertyId) {
      localStorage.setItem('MAZEPROPERTYID', mazePropertyId);
      window.initializeMaze();
    }
  }
}
